/* import __COLOCATED_TEMPLATE__ from './entries-table-row.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { inject as service } from '@ember/service';

export default class EntriesTableRowComponent extends Component
{
	@service store;
	@service errorManager;
	@service confirmation;
	
	@tracked detailsLoading = false;

	@action
	async toggleDetails()
	{
		if (!this.args.entry || this.detailsLoading) {
			return;
		}
		var entry = this.args.entry;
		var opening = !entry.showDetails;

		// Refetch everything the details row displays before opening it, so an
		// operator always sees current data even when timing records changed
		// from another page or machine since this page loaded.
		if (opening)
		{
			this.detailsLoading = true;
			try
			{
				await entry.reload();
				await Promise.all([
					entry.belongsTo('StartTimingRecordId').reload(),
					entry.belongsTo('FinishTimingRecordId').reload(),
					entry.hasMany('intermediateTimingRecords').reload(),
					entry.hasMany('penaltyTimingRecords').reload(),
				]);
				// impulse times are editable from the timing pages
				const startTimingRecord = await entry.get('StartTimingRecordId');
				const finishTimingRecord = await entry.get('FinishTimingRecordId');
				const impulseReloads = [];
				if(startTimingRecord)
				{
					impulseReloads.push(startTimingRecord.belongsTo('startImpulseId').reload());
				}
				if(finishTimingRecord)
				{
					impulseReloads.push(finishTimingRecord.belongsTo('finishImpulseId').reload());
					impulseReloads.push(finishTimingRecord.belongsTo('finishPlungerImpulseId').reload());
				}
				await Promise.all(impulseReloads);
			}
			catch (error)
			{
				// network problem - open anyway and show what we have
			}
			finally
			{
				this.detailsLoading = false;
			}
		}

		entry.set('showDetails', !entry.showDetails);
	}
	
	@action
	async statusSelectionChanged(browserEvent)
	{
		if (!this.args.entry) {
			return;
		}
		var entry = this.args.entry;
		entry.status = browserEvent.target.value;

		try
		{
			await entry.save();
		}
		catch (error)
		{
			entry.rollbackAttributes();
			// Error is displayed by the adapter
		}
	}

	@action
	async classSelectionChanged(browserEvent)
	{
		if (!this.args.entry) {
			return;
		}
		var eventClass = browserEvent.target.value;
		let entry = this.args.entry;
		let originalClassId = entry.ClassId.content;

		try
		{
			if(eventClass == '-')
			{
				entry.ClassId = null;
				await entry.save();
			}
			else
			{

				entry.ClassId = await this.store.findRecord('class', eventClass);
				await entry.save();
			}
		}
		catch (error)
		{
			entry.ClassId = originalClassId;
			// Error is displayed by the adapter
		}
	}
	
	@action
	async courseSelectionChanged(browserEvent)
	{
		if (!this.args.entry) {
			return;
		}
		var course = browserEvent.target.value;
		let entry = this.args.entry;
		let originalCourseId = entry.CourseId.content;

		try
		{
			if(course == '-')
			{
				entry.CourseId = null;
				await entry.save();
			}
			else
			{
				entry.CourseId = await this.store.findRecord('course', course);
				await entry.save();
			}
		}
		catch (error)
		{
			entry.CourseId = originalCourseId;
			// Error is displayed by the adapter
		}
	}
	
	@action
	async deleteEntry()
	{
		if (!this.args.entry) {
			return;
		}
		const entry = this.args.entry;
		
		const startTimingRecord = await entry.get('StartTimingRecordId')
		if(startTimingRecord != null)
		{
			//check to see if there are any impulses associated with this entry
			//if there are, show error and cancel the delete
			const startImpulse = startTimingRecord.get('startImpulseId');
			if(startImpulse.content != null)
			{
				this.errorManager.addError("Entry has a start timing impulse associated. Timing impulses must be disassociated before deletion.", { clearable: true, type: 'validation' });
				return;
			}
		}

		const finishTimingRecord = await entry.get('FinishTimingRecordId')
		if(finishTimingRecord != null)
		{
			this.errorManager.addError("Entry has finish timing impulses associated. Timing impulses must be disassociated before deletion.", { clearable: true, type: 'validation' });
			return;
		}
		
		
		const confirmed = await this.confirmation.confirm({
			title: 'Delete Entry',
			message: 'Delete entry record?',
			confirmLabel: 'Delete',
			confirmStyle: 'danger'
		});
		if(confirmed)
		{
			if(startTimingRecord != null)
			{
				startTimingRecord.deleteRecord();
				try
				{
					await startTimingRecord.save();
				}
				catch (error)
				{
					startTimingRecord.rollbackAttributes();
					// Error is displayed by the adapter
					return;
				}
			}
			entry.deleteRecord();
			try
			{
				await entry.save();
			}
			catch (error)
			{
				entry.rollbackAttributes();
				// Error is displayed by the adapter
				return;
			}
		}
	}
}